<template>
  <v-dialog v-model="active" persistent width="75%">
    <v-card color="cardbg">
      <v-card-title class="headline font-weight-bold">
        {{ title }}
      </v-card-title>
      <v-card-text class="subtitle-1 font-weight-medium card-text-color">
        <span v-html="getText"></span>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-btn
          v-if="cancelBtnLabel"
          class="font-weight-bold"
          color="primary"
          @click="cancelAction"
          rounded
          outlined
          >{{ cancelBtnLabel }}</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          class="font-weight-bold"
          color="primary"
          @click="confirmAction"
          rounded
          depressed
          >{{ confirmBtnLabel }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    confirmDialog() {
      return this.$store.getters["confirm/confirmDialog"];
    },
    active() {
      return this.confirmDialog.active;
    },
    title() {
      return this.$t(this.confirmDialog.title);
    },
    getText() {
      if (this.confirmDialog.params?.msg) {
        return this.$t(this.confirmDialog.message, {
          ...this.confirmDialog.params.msg
        });
      } else {
        return this.$t(this.confirmDialog.message);
      }
    },
    cancelBtnLabel() {
      return this.$t(this.confirmDialog.cancelBtnLabel);
    },
    confirmBtnLabel() {
      return this.$t(this.confirmDialog.confirmBtnLabel);
    }
  },
  methods: {
    cancelAction() {
      if (this.confirmDialog.cancelBtnClb) {
        this.confirmDialog.cancelBtnClb();
      }
      this.$store.commit("confirm/RESET", {
        root: true
      });
    },
    confirmAction() {
      if (this.confirmDialog.confirmBtnClb) {
        this.confirmDialog.confirmBtnClb();
      }
      this.$store.commit("confirm/RESET", {
        root: true
      });
    }
  }
};
</script>
